import { useEffect, useState } from "react";
import axios from "axios";
import { Plus, Save, ShieldCheck, Trash2 } from "lucide-react";
import { API } from "../lib/apiClient";
import { CompanySelect } from "../lib/companies";
import { loadCoverageTemplates, saveCoverageTemplates } from "./CoverageTemplatePicker";

export function CoverageTemplatesCard() {
  const [list, setList] = useState(null);
  const [branches, setBranches] = useState([]);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const [q, setQ] = useState("");
  useEffect(() => {
    loadCoverageTemplates().then(setList).catch(() => setList([]));
    axios.get(`${API}/branches`).then(({ data }) => setBranches(data.map((b) => b.name).filter(Boolean))).catch(() => {});
  }, []);
  const patch = (i, k, v) => setList((l) => l.map((t, j) => (j === i ? { ...t, [k]: v } : t)));
  const save = async () => {
    setBusy(true); setMsg("");
    try { setList(await saveCoverageTemplates(list.map(({ id, ...t }) => (id ? { id, ...t } : t)))); setMsg("Teminat şablonları kaydedildi."); }
    catch (e) { setMsg(e?.response?.data?.detail || "Kaydedilemedi"); } finally { setBusy(false); }
  };
  const low = (s) => (s || "").toLocaleLowerCase("tr");
  const shown = (list || []).map((t, i) => [t, i]).filter(([t]) => !q || low(`${t.company} ${t.branch} ${t.name} ${t.text}`).includes(low(q)));
  return (
    <section className="panel settings-card" data-testid="coverage-templates-card">
      <div className="settings-card-head"><ShieldCheck size={16} /> <h2>Teminat şablonları</h2></div>
      <p className="privacy-note">Kasko, TSS ve İMM tekliflerinde şirket satırının altında tek dokunuşla kullanılır. Şirket veya branş boş bırakılırsa tümünde görünür.</p>
      {list && list.length > 3 && <input className="cov-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Şablon ara: şirket, branş, metin…" data-testid="cov-tpl-search" />}
      {list && list.length === 0 && <p className="dim" data-testid="cov-tpl-empty">Henüz şablon yok. Yeni şablon ekleyin veya teklif ekranında "Şablon olarak kaydet"i kullanın.</p>}
      <div className="cov-tpl-list">
        {shown.map(([t, i]) => (
          <div key={t.id || `new-${i}`} className="cov-tpl-item" data-testid={`cov-tpl-item-${i}`}>
            <div className="cov-tpl-meta">
              <CompanySelect label="Şirket" name={`cov-company-${i}`} value={t.company} onChange={(e) => patch(i, "company", e.target.value)} />
              <label className="field"><span>Branş</span>
                <select value={t.branch} onChange={(e) => patch(i, "branch", e.target.value)} data-testid={`cov-tpl-branch-${i}`}>
                  <option value="">Tüm branşlar</option>
                  {[...new Set([...branches, t.branch].filter(Boolean))].map((b) => <option key={b}>{b}</option>)}
                </select></label>
              <label className="field"><span>Şablon adı</span><input value={t.name} onChange={(e) => patch(i, "name", e.target.value)} data-testid={`cov-tpl-name-${i}`} /></label>
            </div>
            <textarea rows="3" value={t.text} onChange={(e) => patch(i, "text", e.target.value)} placeholder="Teminat metni" data-testid={`cov-tpl-text-${i}`} />
            <button type="button" className="icon-button cov-tpl-del" onClick={() => setList((l) => l.filter((_, j) => j !== i))} title="Sil" data-testid={`cov-tpl-delete-${i}`}><Trash2 size={15} /></button>
          </div>
        ))}
      </div>
      <div className="settings-actions">
        <button type="button" className="outline-button" onClick={() => setList((l) => [...(l || []), { company: "", branch: "", name: "", text: "" }])} data-testid="cov-tpl-add"><Plus size={14} /> Yeni şablon</button>
        <button type="button" className="primary-button" onClick={save} disabled={busy || !list} data-testid="cov-tpl-save"><Save size={14} /> Kaydet</button>
      </div>
      {msg && <small className="signature-hint" data-testid="cov-tpl-msg">{msg}</small>}
    </section>
  );
}
